import { render, staticRenderFns } from "./ButtonScroll.vue?vue&type=template&id=52ad70e0&"
import script from "./ButtonScroll.vue?vue&type=script&lang=js&"
export * from "./ButtonScroll.vue?vue&type=script&lang=js&"
import style0 from "./ButtonScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports